export default "<div class=\"spinner-wrapper\">\r\n  <div class=\"donut\"></div>\r\n</div>";